import { useLocation, useParams } from 'react-router-dom';

export const buildPublicSitePath = (path: string, previewSubdomain?: string | null): string => {
  const normalizedPath = !path || path === '/' ? '/' : path.startsWith('/') ? path : `/${path}`;

  if (!previewSubdomain) {
    return normalizedPath;
  }

  return normalizedPath === '/'
    ? `/website/${previewSubdomain}`
    : `/website/${previewSubdomain}${normalizedPath}`;
};

export const usePublicSitePath = () => {
  const { pathname } = useLocation();
  const { subdomain } = useParams<{ subdomain?: string }>();

  const previewSubdomain = subdomain || pathname.match(/^\/website\/([^/]+)/)?.[1] || null;

  return (path: string) => buildPublicSitePath(path, previewSubdomain);
};
